/**
 * 工具函数：尝试解析 JSON
 * @param {string} text - 要解析的文本
 * @returns {object|null} - 解析成功返回对象，失败返回 null
 */
export const tryParseJSON = (text) => {
    if (typeof text !== 'string') return null;
    const trimmed = text.trim();
    if (!trimmed || (trimmed[0] !== '{' && trimmed[0] !== '[')) {
        return null;
    }
    try {
        return JSON.parse(trimmed);
    } catch (error) {
        return null;
    }
};

